import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthProvider } from "../customHooks/authContext";

function ProtectedRoute({
  children,
  allowedRoles = [],
  adminOnly = false,
  operatorOnly = false,
  schoolOnly = false,
}) {
  const { isAuthenticated, role } = useAuthProvider();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const requiredRoles =
    allowedRoles.length > 0
      ? allowedRoles
      : [
          adminOnly && "Administrador",
          operatorOnly && "Operador",
          schoolOnly && "Escuela",
        ].filter(Boolean);

  if (requiredRoles.length > 0 && !requiredRoles.some((requiredRole) => role.includes(requiredRole))) {
    return <Navigate to="/members" replace />;
  }

  return children;
}

export default ProtectedRoute;
